import { StyleSheet } from 'react-native';
import Typography from '../../../../shared/constants/Typography';

export const createCardStyles = (theme: any) =>
  StyleSheet.create({
    scoreCard: {
      flex: 1,
      flexDirection: 'row',
      backgroundColor: theme.scoreBoardCardBG,
      justifyContent: Typography.contentAlign.spaceBetween,
      borderRadius: Typography.radius.radius8,
      borderColor: theme.scoreBoardCardBorder,
      borderWidth: Typography.borderWidth.borderWidth005,
      padding: Typography.padding.padding24,
      alignItems: Typography.textAlign.centerAlign
    },
    scoreCardHeader: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
      alignItems: Typography.textAlign.centerAlign,
    },
    scoreCardTitle: {
      fontSize: Typography.fontSize.fontSize18,
      fontWeight: Typography.fontWeight.medium,
      color: theme.scoreBoardCardTitle,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight20
    },
    scoreCardBody: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
    },
      scoreCardCount: {
      fontSize: Typography.fontSize.fontSize34,
      fontWeight: Typography.fontWeight.semiBold,
      color: theme.scoreBoardCardCount,
      fontFamily: Typography.fontFamily.inter,
    },
  });
